import {
  Button,
  Col,
  Container,
  Form,
  Offcanvas,
  Row,
  Card,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import BG2 from "../assets/contact-us-bg.jpg";
import {useState } from "react";
import { GoDotFill } from "react-icons/go";
import "../utils/effectCSS/Effects.css";
import { toast } from "react-toastify";
import axios from "axios";

const ContactUs = () => {
  //Email Data
  let [data, setData] = useState({
    name: "",
    email: "",
    about: "",
    value: false,
  });

  //Styles
  const listStyle = {
    background: "transparent",
    color: "#778da9",
    border: "0",
    fontSize: "1.10rem",
  };

  //Policy States
  const [showPolicyView, setShowPolicyView] = useState(false);
  const handlePolicyViewClose = () => setShowPolicyView(false);
  const handlePolicyViewShow = () => setShowPolicyView(true);

  // Errors States
  const [errors, setErrors] = useState({});

  // Event change function
  const handleChange = (event, property) => {
    const value =
      property === "value" ? event.target.checked : event.target.value;
    setData({
      ...data,
      [property]: value,
    });
  };

  // Clear Data and Errors function
  const clearData = () => {
    setData({
      name: "",
      email: "",
      about: "",
      value: false,
    });
    setErrors({});
  };

  //Validation
  const validateForm = () => {
    const newErrors = {};
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!data.name) newErrors.name = "Name is required.";
    if (!data.email) {
      newErrors.email = "Email is required.";
    } else if (!emailPattern.test(data.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!data.about) newErrors.about = "Please describe how we can help.";
    if (!data.value) newErrors.value = "You must accept the privacy policy.";

    return newErrors;
  };

  // Send Email API CALL
  const sendEmail = async () => {
    try {
      const response = await axios.post("/.netlify/functions/sendEmail", {
        name: data.name,
        email: data.email,
        message: data.about,
      });
  
      console.log(response.data);
      toast.success("Contacted successfully!");
    } catch (error) {
      console.error("Failed to contact:", error);
      toast.error("Failed to contact, please try again later.");
    }
  };
  
  //Handle Form Submission
  const submitForm = (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      if (!data.value) {
        toast.warn("Please accept our privacy policy");
      }
    } else {
      setErrors({});
      if (data.value) {
        sendEmail();
      }
      clearData();
    }
  };

  // Privacy Policy View Component
  const PrivacyPolicyView = () => {
    return (
      <>
        <Offcanvas
          style={{ width: "800px" }}
          show={showPolicyView}
          onHide={handlePolicyViewClose}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Container className="ms-4 mt-4">
              <h2 className="">
                <b>Privacy Policy</b>
              </h2>
            </Container>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Container fluid>
              <Card
                className="border border-0"
                style={{ background: "transparent", margin: "0", padding: "0" }}
              >
                <Card.Body>
                  {/* <h2 className="p-4">
                    <b>Privacy Policy</b>
                  </h2> */}
                  <hr
                    className="ms-4"
                    style={{
                      width: "10%",
                      border: "1px solid blue",
                      margin: "0 ",
                    }}
                  />
                  <div style={{ color: "#778da9" }}>
                    {" "}
                    <p className="mt-4 ms-4" style={{ fontSize: "1.25rem" }}>
                      <b>What types of information do we collect?</b>
                    </p>
                    <p className="mt-4 ms-4" style={{ fontSize: "1.10rem" }}>
                      We gather Information when you interact with our Website,
                      such as when you Register, Subscribe to our Newsletter,
                      Participate in Surveys, or Fill Out Forms.
                    </p>
                    <p className="mt-4 ms-4" style={{ fontSize: "1.10rem" }}>
                      Some data requests may be marked as Voluntary or Optional,
                      So you can choose whether or not to provide them.
                    </p>
                    <p className="mt-4 ms-4" style={{ fontSize: "1.10rem" }}>
                      When you place an order or register on our Site, We may
                      ask for your Name, Email, Mailing Address, or Phone
                      Number, But you can also browse Anonymously.
                    </p>
                  </div>
                  <p
                    className="mt-5 ms-4"
                    style={{ fontSize: "1.50rem", color: "blue" }}
                  >
                    <b>How We Use Your Information</b>
                  </p>
                  <div style={{ color: "#778da9" }}>
                    <p className="mt-4 ms-4" style={{ fontSize: "1.10rem" }}>
                      Any of the information we collect from you may be used in
                      one of the following ways:
                    </p>
                    <ListGroup variant="flush">
                      <ListGroupItem style={listStyle}>
                        <GoDotFill size={15} color="blue" />
                        <span>
                          We use your data to tailor your Experience, Allowing
                          us to respond more Effectively to your Needs.
                        </span>
                      </ListGroupItem>
                      <ListGroupItem style={listStyle}>
                        <GoDotFill size={15} color="blue" />
                        <span>
                          Your information helps us address your inquiries and
                          provide more efficient Customer Service.
                        </span>
                      </ListGroupItem>
                      <ListGroupItem style={listStyle}>
                        <GoDotFill size={15} color="blue" />
                        <span>
                          {" "}
                          The Email address you provide may be used to send
                          updates about your Order, as well as Occasional
                          Company News, Offers, and Related Product or Service
                          Details. We respect your Privacy, and you can choose
                          to opt out of Marketing Communications at any time.
                        </span>
                      </ListGroupItem>
                      <ListGroupItem
                        style={listStyle}
                        className="d-flex align-items-center"
                      >
                        <GoDotFill size={15} color="blue" />
                        <span className="ms-2">
                          We gather feedback and information to Improve our
                          Website, Ensuring better offerings and User
                          Experience.
                        </span>
                      </ListGroupItem>
                    </ListGroup>
                  </div>
                </Card.Body>
              </Card>
            </Container>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  };

  return (
    <>
      <Container
        className="p-0"
        fluid
        style={
          {
            //backgroundImage: "url(" + BG + ")",
            //backgroundColor: "#cecede",
          }
        }
      >
        <div
          style={{
            height: "80px",
          }}
        ></div>
        <Row className="g-0">
          <Col
            style={{
              backgroundColor: "#f2f2f2",
            }}
            className="p-5"
            lg={7}
          >
            <h1>Let Us Safeguard Your Assets.</h1>
            <p>Thank you for your interest in IDM 360 Analytics</p>
            <p>
              Whether you have a question, need assistance, or want to explore
              how our innovative Cybersecurity strategies can empower your
              Business, We’re here to help — Connect with us now!
            </p>
            {/* {JSON.stringify(data)} */}
            <Form onSubmit={submitForm}>
              {/* Name field */}
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  id="transparent-input"
                  placeholder="Full Name"
                  onChange={(event) => handleChange(event, "name")}
                  value={data.name}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Email field */}
              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  id="transparent-input"
                  placeholder="Email Address"
                  onChange={(event) => handleChange(event, "email")}
                  value={data.email}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Description field */}
              <Form.Group className="mb-2">
                <Form.Control
                  as={"textarea"}
                  id="transparent-input"
                  placeholder="How can we Help?"
                  rows={2}
                  onChange={(event) => handleChange(event, "about")}
                  value={data.about}
                  isInvalid={!!errors.about}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.about}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Agreement field */}
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  value="agree"
                  checked={data.value}
                  onChange={(event) => handleChange(event, "value")}
                  isInvalid={!!errors.value}
                  feedback={errors.value}
                  label={<>Do you acknowledge and accept the terms of the </>}
                  style={{ display: "inline-block", marginRight: "5px" }} // Align checkbox inline with space between
                />
                <Button
                  style={{
                    textDecoration: "none",
                    color: "red",
                    fontSize: "1.20rem",
                    fontWeight: "bold",
                    border: "0",
                    background: "transparent",
                    margin: "0",
                    padding: "0 0 6px 0",
                    display: "inline-block", // Make button inline
                  }}
                  onClick={(event) => {
                    event.stopPropagation(); // Prevent the checkbox from toggling
                    handlePolicyViewShow(); // Trigger the policy view
                  }}
                >
                  Privacy Policy
                </Button>{" "}
                ?
              </Form.Group>

              <Container>
                <div className="d-flex justify-content-between">
                  <div className="ms-5">
                    <Button
                      className="text-uppercase"
                      id="hover-change-color"
                      variant="primary"
                      type="submit"
                    >
                      Send &rarr;
                    </Button>
                  </div>
                  <div className="me-5">
                    <Button
                      className="text-uppercase"
                      id="hover-change-color"
                      variant="primary"
                      onClick={clearData}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              </Container>
            </Form>
          </Col>
          <Col
            // className="d-flex"
            className="d-none d-lg-flex"
            lg={5}
          >
            {/* {PrivacyPolicyView()} */}
            <PrivacyPolicyView />
            <img className="img-fluid" src={BG2} alt="Contact Us" />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactUs;
